export enum C3ProductBillOfMaterialsLineItemType {
    Hardware = 'Hardware',
    Product = 'Product',
}